/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTrends.defs.js'
export * as $defs from './getTrends.defs.js'
